import { trigger, state, style, transition, animate } from '@angular/animations';

export const fadeInAnimation = trigger('fadeIn', [
    state('void', style({ opacity: 0.1 })),
    transition(':enter', [
      animate('0.8s ease-in', style({ opacity: 1 }))
    ])
  
]);
